import { slicedToArray as _slicedToArray, createForOfIteratorHelper as _createForOfIteratorHelper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState } from 'react';
import { Box, Heading, Input, Button, IconArrowRightOutline, Paragraph, IconCheckmarkCircleOutline } from '@zillow/constellation';
import PAFormStepper from './PAFormStepper.js';

var PAFormStepperBlock = {
  Component: function Component() {
    var _useState = useState('welcome'),
      _useState2 = _slicedToArray(_useState, 2),
      visibleStepName = _useState2[0],
      setVisibleStepName = _useState2[1];
    var _useState3 = useState('agent'),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedWelcomeTile = _useState4[0];
      _useState4[1];
    var submit = function submit(e) {
      e.preventDefault();
      switch (visibleStepName) {
        case 'welcome':
          setVisibleStepName('agent-email');
          return;
        case 'agent-email':
          setVisibleStepName('agent-phone');
          return;
        case 'agent-phone':
          setVisibleStepName('agent-org');
          return;
        case 'agent-org':
          setVisibleStepName('agent-thank-you');
      }
      console.log('here');
      var data = new FormData(e.currentTarget);
      var json = {};
      var _iterator = _createForOfIteratorHelper(data.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          json[key] = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      console.log('json:', json);
    };
    return /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: 'skyblue'
      }
    }, /*#__PURE__*/React.createElement(PAFormStepper, {
      onSubmit: submit,
      visibleStepName: visibleStepName,
      onClose: function onClose() {
        return setVisibleStepName('welcome');
      }
    }, /*#__PURE__*/React.createElement(PAFormStepper.Step, {
      progressBar: selectedWelcomeTile === 'agent' && {
        current: 1,
        total: 4
      },
      name: "welcome"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
      level: "5",
      fontFamily: "serif",
      textAlign: "center"
    }, "Who Are you?"), /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      fontFamily: "serif",
      textAlign: "center"
    }, "What's your name?"), /*#__PURE__*/React.createElement(Input, {
      placeholder: "First and last name",
      name: "name"
    }), /*#__PURE__*/React.createElement(Button, {
      buttonType: "primary",
      icon: /*#__PURE__*/React.createElement(IconArrowRightOutline, null),
      iconPosition: "end",
      fluid: true
    }, "Continue"))), /*#__PURE__*/React.createElement(PAFormStepper.Step, {
      progressBar: {
        current: 2,
        total: 4
      },
      name: "agent-email",
      onBack: function onBack() {
        return setVisibleStepName('welcome');
      }
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      fontFamily: "serif",
      textAlign: "center"
    }, "What's your email?"), /*#__PURE__*/React.createElement(Input, {
      placeholder: "Email",
      name: "email"
    }), /*#__PURE__*/React.createElement(Button, {
      buttonType: "primary",
      icon: /*#__PURE__*/React.createElement(IconArrowRightOutline, null),
      iconPosition: "end",
      fluid: true
    }, "Continue"))), /*#__PURE__*/React.createElement(PAFormStepper.Step, {
      progressBar: {
        current: 3,
        total: 4
      },
      name: "agent-phone",
      onBack: function onBack() {
        return setVisibleStepName('agent-email');
      }
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      fontFamily: "serif",
      textAlign: "center"
    }, "What's your phone number?"), /*#__PURE__*/React.createElement(Input, {
      placeholder: "Phone",
      name: "phone"
    }), /*#__PURE__*/React.createElement(Button, {
      buttonType: "primary",
      icon: /*#__PURE__*/React.createElement(IconArrowRightOutline, null),
      iconPosition: "end",
      fluid: true
    }, "Continue"))), /*#__PURE__*/React.createElement(PAFormStepper.Step, {
      progressBar: {
        current: 4,
        total: 4
      },
      name: "agent-org",
      onBack: function onBack() {
        return setVisibleStepName('agent-phone');
      }
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      fontFamily: "serif",
      textAlign: "center"
    }, "What's your organization size?"), /*#__PURE__*/React.createElement(Button, {
      buttonType: "primary",
      disabled: visibleStepName !== 'agent-org',
      fluid: true
    }, "Submit"))), /*#__PURE__*/React.createElement(PAFormStepper.Step, {
      name: "agent-thank-you"
    }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Paragraph, {
      textAlign: "center"
    }, /*#__PURE__*/React.createElement(IconCheckmarkCircleOutline, {
      fontColor: "brand",
      size: "lg"
    })), /*#__PURE__*/React.createElement(Heading, {
      level: "3",
      fontFamily: "serif",
      textAlign: "center"
    }, "Thank you!"))), /*#__PURE__*/React.createElement(PAFormStepper.Footer, null, "this is the footer")));
  },
  metadata: {
    name: 'zrs-cms/pa-form-stepper',
    title: 'PA Form Stepper',
    description: 'A component for rendering a multi-step form',
    icon: 'businessperson',
    category: 'more',
    keywords: ['pa', 'form', 'stepper'],
    attributes: {}
  }
};

export { PAFormStepperBlock as default };
